<button
    [soti-tooltip]="chatToolTip | xsI18n"
    delay="500"
    placement="bottom"
    *ngIf="chatToggleEnabled && chatSupportEnabled && userChatAccess"
    (click)="toggleChatView()"
    class="button-icon"
    [class.active-button]="showChatPopup"
>
    <svg-icon-chat-navigation></svg-icon-chat-navigation>
    <ng-container *ngIf="unreadChatNotifications$ | async as unreadChatNotification">
    <div *ngIf="unreadChatNotification > 0" class="count-circle">
        <span class="count-number">{{
        unreadChatNotification > MAX_ITEMS ? MAX_ITEMS + '+' : unreadChatNotification
        }}</span>
    </div>
    </ng-container>
</button>